import autoComplete from "@tarekraafat/autocomplete.js";

export default function autoCompleteInit () {
    const input = document.querySelector("#site-search");
    const form = input?.closest('form');

    if (!input || typeof autocomplete === 'undefined') return;

    const autoCompleteJS = new autoComplete({
        selector: "#site-search",
        data: {
            src: autocomplete,
        },
        debounce: 200,
        resultItem: {
            highlight: true,
        },
        events: {
            input: {
                selection (event) {
                    input.value = event.detail.selection.value;
                },
            },
        },
    });

    input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            form.submit();
        }
    });
}